/* MUI */
import { Box, Chip, Typography } from '@mui/material';
import { useTheme } from '@mui/material/styles';

/* React */
import React from 'react';

export const CustomTooltip = ({
    active,
    dynamicColorsFn,
    label,
    labelMap,
    payload,
    titleElement
}) => {
    const theme = useTheme();
    if (active && payload && payload.length) {
        const entries = payload;

        let titleHTML = (
            <Typography
                sx={{
                    fontWeight: 600,
                    margin: '0'
                }}
            >
                {label}
            </Typography>
        );

        if (titleElement && labelMap && dynamicColorsFn) {
            const title = labelMap[titleElement];
            let titleValue = null;

            Object.values(entries).forEach((value) => {
                // value.dataKey is entryLabel
                if (value.dataKey === titleElement) {
                    titleValue = value.payload[value.dataKey];
                }
            });

            if (titleValue !== 0) {
                titleHTML = (
                    <Box
                        display="flex"
                        alignContent="center"
                        sx={{
                            fontWeight: 600,
                            margin: '0'
                        }}
                    >
                        <Typography mr="16px" variant="span">
                            {label}
                        </Typography>
                        <Typography
                            variant="span"
                            sx={{
                                color: theme.palette.qbrFirstReports[
                                    titleElement
                                ],
                                fontWeight: 600
                            }}
                        >
                            {title.name}
                        </Typography>
                        <Chip
                            label={titleValue}
                            size="small"
                            sx={{
                                backgroundColor: dynamicColorsFn(titleValue),
                                marginBottom: '8px',
                                marginLeft: '8px'
                            }}
                            variant="blackText"
                        />
                    </Box>
                );
            }
        }

        const EntriesHTML = entries.map((entry) => {
            const entryDataKeylabel = entry.dataKey;

            if (titleElement) {
                if (entryDataKeylabel === titleElement) {
                    return (
                        <span
                            key={`customTooltip_title_${entry.name}_${entry.payload.day}`}
                        />
                    );
                }
            }

            let labelHTML = <strong>{entryDataKeylabel}:</strong>;

            if (labelMap) {
                labelHTML = (
                    <Typography sx={{ fontWeight: 600 }}>
                        {labelMap[entryDataKeylabel].name}
                    </Typography>
                );
            }

            let value = entry.payload[entry.dataKey];
            if (value === 0) {
                value = '';
            }
            const valueColor = entry.color;
            let valueHTML = (
                <strong style={{ color: valueColor }}>&nbsp;{value}</strong>
            );
            if (dynamicColorsFn && value) {
                valueHTML = (
                    <Chip
                        label={value}
                        variant="blackText"
                        size="small"
                        sx={{
                            backgroundColor: dynamicColorsFn(value),
                            marginBottom: '2px',
                            marginLeft: '8px'
                        }}
                    />
                );
            }
            return (
                <Box
                    display="flex"
                    alignItems="center"
                    key={`customTooltip_${entry.name}_${entry.payload.day}`}
                >
                    <Box
                        sx={{
                            backgroundColor:
                                theme.palette.qbrFirstReports[entry.dataKey],
                            borderRadius: '50%',
                            height: '13px',
                            mr: '8px',
                            width: '13px'
                        }}
                    />
                    {labelHTML}
                    {valueHTML}
                </Box>
            );
        });

        return (
            <Box
                sx={{
                    backgroundColor:
                        theme.palette.tooltips.lightTooltip.background,
                    border: '1px solid',
                    borderColor: theme.palette.tooltips.lightTooltip.border,
                    boxShadow: theme.shadows[24],
                    lineHeight: '24px',
                    margin: '0',
                    padding: '8px',
                    width: '400px'
                }}
            >
                {titleHTML}
                <Box
                    style={{
                        marginLeft: '50px',
                        marginTop: '4px'
                    }}
                >
                    {EntriesHTML}
                </Box>
            </Box>
        );
    }

    return null;
};
